import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Header = ({ count, urls, canCreate, canExport, onExportClick }) => (
  <div className="flex items-start justify-between gap-6 mb-6">
    <div className="flex items-baseline gap-3">
      <h1 className="text-2xl font-semibold text-slate-900">
        {I18n.t("navigation.mbc_contracts")}
      </h1>
      <span className="text-sm text-slate-500">
        {count} {count === 1 ? "marché" : "marchés"}
      </span>
    </div>

    <div className="flex items-center gap-2">
      {canExport && (
        <button
          type      = "button"
          onClick   = {onExportClick}
          className = "inline-flex items-center gap-2 h-9 px-3 rounded-md bg-white border border-slate-200 text-[13px] font-medium text-slate-700 hover:bg-slate-50"
        >
          <FontAwesomeIcon icon="file-csv" className="text-[12px]" />
          CSV
        </button>
      )}
      {canCreate && urls.new && (
        <a
          href      = {urls.new}
          className = "inline-flex items-center gap-2 h-9 px-3 rounded-md bg-brand-500 text-[13px] font-medium text-white hover:bg-brand-600"
        >
          <FontAwesomeIcon icon="plus" className="text-[12px]" />
          {I18n.t("navigation.mbc_contracts")}
        </a>
      )}
    </div>
  </div>
)

export default Header
